<template>
  <router-link
    class="inline text-nucleus-primaryBlue hover:text-nucleus-primaryMouseOver underline transition text-sm"
    :class="{ 'text-nucleus-white hover:text-nucleus-white': white }"
    :to="to"
    >{{ name }}</router-link
  >
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    to: String,
    name: String,
    white: Boolean,
  },
})
export default class TextLink extends Vue {}
</script>
